<template>
  <div>
    <generic-container
      :title="$t('latest pets')"
      icon="cat"
      :searchable="true"
      :show_plus="true"
      :configurable="true"
      v-bind:configure_modal="configure_modal"
      v-on:add="add"
      v-on:filter="filter"
    >
      <div class="ui three link cards">
        <div
          class="card"
          v-for="(pet, index) in pets"
          v-bind:key="index"
          v-on:click="show_pet(pet)"
        >
          <div class="content">
            <img
              class="right floated mini ui image"
              src="/images/icons/pet.png"
            />
            <div class="header">{{ pet.name }}</div>
            <div class="meta">
              <span>{{
                pet.create_date
                  | formatDate(enterprise_setup.simple_date_format)
              }}</span>
            </div>
            <p></p>
          </div>
        </div>
      </div>
    </generic-container>
    <template v-for="(mdl, index) in pet_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:destroy="destroy"
        v-on:succedded="succedded"
      ></component>
    </template>
  </div>
</template>

<script>
import { local_api, clone, enterprise_setup } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./PetConfigureModal";
import PetModal from "./PetModal";

// @ is an alias to /src
export default {
  name: "Customer",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      pets: [],
      all_pets: [],
      // customer: {},
      configure_modal: ConfigureModal,
      pet_modals: [],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    add() {
      this.pet_modals.push(PetModal);
    },
    succedded(pet) {
      let trgtIdx = this.pets.findIndex((n) => n.pet_id == pet.pet_id);
      if (trgtIdx == -1) {
        this.pets.push(pet);
      } else {
        this.pets.splice(trgtIdx, 1, pet);
      }
    },
    destroy() {
      this.pet_modals = [];
      // this.customer = {};
    },
    filter(filter) {
      // console.log(filter);
      if (filter == "") this.pets = clone(this.all_pets);
      else
        this.pets = this.all_pets.filter((n) =>
          n.name.toUpperCase().includes(filter.toUpperCase()),
        );
    },
    show_pet(pet) {
      // this.customer = customer;
      this.$router.push({
        name: "PetView",
        query: { i: pet.uuid },
      });
      // this.customer_modals.push(CustomerModal);
    },
  },
  mounted() {
    local_api(this, "post", "/pet/do-get-latest")
      .then((pets) => {
        let _pets = pets.sort(function(a, b) {
          if (a.name > b.name) return 1;
          if (b.name > a.name) return -1;
          return 0;
        });
        this.pets = _pets;
        this.all_pets = clone(_pets);
      })
      .catch((err) => {
        window.jQuery(this.$el).toast({
          message: err,
          class: "error",
          showImage: "/images/error.png",
          classImage: "avatar",
          title: "Error",
          showProgress: "bottom",
          classProgress: "blue",
        });
      });
  },
  watch: {},
};
</script>
